
import Section from '../Section';

export default class Footer extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.footerWrapper = /** @type {HTMLElement} */ (document.querySelector('.footer-wrapper'));
    this.footer = /** @type {HTMLElement} */ (document.querySelector('footer'));
    this.pageContainer = /** @type {HTMLElement} */ (document.querySelector('#PageContainer'));
    this.fixFooterToBottom();

    let self = this;

    document.addEventListener('shopify:section:load', this.fixFooterToBottom);
    document.addEventListener('shopify:section:unload', this.fixFooterToBottom);
    document.addEventListener('shopify:section:select', this.fixFooterToBottom);
    document.addEventListener('shopify:section:deselect', this.fixFooterToBottom);
    document.addEventListener('shopify:section:reorder', this.fixFooterToBottom);
  }

  fixFooterToBottom = () => {
    let heightOfContent = this.pageContainer.offsetHeight + this.footerWrapper.offsetHeight;

    this.footerWrapper.classList.remove('fix-to-bottom');

    // If the viewport is higher than the content.
    if(window.innerHeight > heightOfContent) {
      this.footerWrapper.classList.add('fix-to-bottom');
    }
  }

  onBlockSelect = () => {
    this.fixFooterToBottom();
  }
}
